/* global I18n */

import class_names from "classnames"
import {use_daltonize_image} from "components/hooks"
import {useImage} from "react-image"
import PerspectiveIcon from "../perspective_icon"
import React from "react"

const TermImage = ({image}) => {
  let {src} = useImage({srcList: image.image_url})
  src = use_daltonize_image(src)

  return (
    <>
      {image.perspective &&
        <PerspectiveIcon
          perspective={image.perspective}
          tooltip_placement="top"
        />}
      <img
        crossOrigin="anonymous"
        src={src}
        onLoad={(e) => {
          // we need to set these values after it is loaded because
          // otherwise it would show it while it is loading
          e.target.alt = image.alt_text || image.image_title

          if (image.image_title) e.target.title = image.image_title
        }}
      />
    </>
  )
}

export default TermImage
